import React from "react";
import { BackIcon } from "../../Assets/Icons";

const BackButton = ({ onBackClick = () => {}, Icon }) => {
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
      console.log("clicked");
    }
  };

  return (
    <>
      <div className="back-btn-wrapper" onClick={handleBackClick}>
        <span className="back-btn">{!!Icon && Icon}</span>
      </div>
    </>
  );
};

export default BackButton;
